import { useSelector } from "react-redux";
import styled from './Loading.module.css'
const LoadingComponent = ({ loadingGroup, loadingDesign, children }) => {
  const selectedData = useSelector(state => state.loading[loadingGroup]);

  return (
    selectedData ? (loadingDesign ||
      <div className="flex justify-center items-center h-full">
        <div className={styled.spinner}></div>
      </div>) : children
  );
};

export default LoadingComponent;
